import styled from 'styled-components';
import MUIIconButton from '@material-ui/core/IconButton';
import PropTypes from 'prop-types';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { Spacings } from '../../../styleConstants';

const StyledIconButton = styled(MUIIconButton)`
  background-color: ${({ theme, $bgColor }) => {
    return $bgColor || theme.colors.whiteV2;
  }};
  border-radius: ${Spacings.SPACING_2B};
  height: ${Spacings.SPACING_8B};
  width: ${Spacings.SPACING_8B};
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  padding: ${Spacings.SPACING_0B};
  &:hover {
    background-color: ${({ theme, $hovDisabled, $bgColor }) => {
      return $hovDisabled
        ? $bgColor || theme.colors.whiteV2
        : theme.colors.white;
    }};
  }
`;

const IconButton = ({ children, className, onClick, bgColor, hovDisabled }) => (
  <StyledIconButton
    disableRipple
    className={className}
    onClick={onClick}
    $bgColor={bgColor}
    $hovDisabled={hovDisabled}
  >
    {children}
  </StyledIconButton>
);

export default IconButton;

IconButton.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  bgColor: PropTypes.string,
  hovDisabled: PropTypes.bool
};

IconButton.defaultProps = {
  className: '',
  onClick: () => {},
  bgColor: '',
  hovDisabled: false
};
